@if (guideline._id) {
  <div class="modal fade" id="edit-guideline-modal" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit</h5>
          <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form #editGuidelineForm="ngForm">
            <div class="d-flex flex-column">
              <div class="form-group">
                <label>Title <span class="text-danger small">(required)</span></label>
                <input type="text" class="form-control" [ngClass]="setClassInvalidTpl(guidelineTitle)" #guidelineTitle="ngModel" name="title"
                  [(ngModel)]="guideline.title" placeholder="Title" required>
              </div>
              <div class="form-group">
                <label>URL <span class="text-danger small">(required)</span></label>
                <input type="url" class="form-control" [ngClass]="setClassInvalidTpl(guidelineUrl)" #guidelineUrl="ngModel" name="url"
                  [(ngModel)]="guideline.url" placeholder="https://example.com">
                </div>
                <div class="form-group">
                  <label>Department <span class="text-danger small">(required)</span></label>
                  <select class="form-control" name="department" [(ngModel)]="guideline.department">
                    <option value="" disabled>Select department</option>
                    @for (department of guidelineDepartments; track department) {
                      <option [value]="department">{{department}}</option>
                    }
                  </select>
                </div>
                <div class="form-group">
                  <label>Pinned <span class="text-danger small">(required)</span></label>
                  <select class="form-control" name="pinned" [(ngModel)]="guideline.pinned">
                    <option value="" disabled>Select pinned</option>
                    <option [value]="true">Yes</option>
                    <option [value]="false">No</option>
                  </select>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
              [disabled]="!editGuidelineForm.form.valid"
              (click)="updateGuideline(guideline)">
            <i class="fa fa-floppy-o"></i> Save
          </button>
        </div>
      </div>
    </div>
  </div>
}